import { Check } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left: image */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl border border-white/10">
            <img
              src="https://customer-assets.emergentagent.com/job_local-web-builder-17/artifacts/lk4htd8i_IMG_3195.jpeg"
              alt="Elijah Almonte"
              className="w-full h-full object-cover object-[60%_center]"
              data-testid="about-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <div>
                <div className="font-display text-2xl text-white">Elijah Almonte</div>
                <div className="text-xs uppercase tracking-[0.22em] text-white/60 mt-1">
                  Founder · Almonte Sites
                </div>
              </div>
              <div className="hidden sm:block text-right">
                <div className="font-display text-3xl italic text-blue-400">AS</div>
              </div>
            </div>
          </div>
          {/* floating accent */}
          <div className="absolute -bottom-6 -right-6 h-24 w-24 rounded-2xl border border-blue-500/40 bg-blue-500/5 hidden md:block" />
        </div>

        {/* Right: copy */}
        <div className="lg:col-span-7">
          <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
            About
          </span>
          <h2
            data-testid="about-headline"
            className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1]"
          >
            Built By Someone Who{" "}
            <span className="italic text-white/90">Understands Hustle</span>
          </h2>
          <div className="mt-7 space-y-5 text-white/65 leading-relaxed max-w-2xl">
            <p>
              I&apos;m a young entrepreneur who builds websites for local
              businesses. Not template-and-pray websites — clean, modern sites
              with one job: turn the people who land on them into customers.
            </p>
            <p>
              I focus on speed, sharp design, and lead generation. I know
              business owners care about calls, bookings, estimates, and
              trust. That&apos;s what every page I build is engineered to do.
            </p>
            <p className="text-white/80">
              The goal is simple: make websites that actually help businesses
              grow.
            </p>
          </div>

          <ul className="mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-xl">
            {[
              "Built for real business results",
              "Mobile-first, always",
              "Direct 1-on-1 communication",
              "Honest pricing, fast turnaround",
            ].map((point) => (
              <li
                key={point}
                data-testid={`about-point-${point.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className="flex items-start gap-3 text-sm text-white/75"
              >
                <span className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full border border-blue-500/40 bg-blue-500/10">
                  <Check size={12} className="text-blue-400" />
                </span>
                {point}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex items-center gap-5">
            <span className="font-display text-3xl italic text-white">— EA</span>
            <span className="text-xs uppercase tracking-[0.22em] text-white/40">
              Signature
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
